/** Admin: an owner's email alert preferences (owner-twin via makeOwnerApi). */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { makeOwnerApi } from '../../../../src/api/adminAsOwner';
import EmailAlertsScreen from '../../../../src/screens/EmailAlertsScreen';

export default function AdminOwnerEmailAlertsScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const client = React.useMemo(() => makeOwnerApi(id ?? ''), [id]);
  return <EmailAlertsScreen client={client} adminOwnerId={id} />;
}
